module.exports = __webpack_public_path__ + "static/media/song_english.391ef151.png";